import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { AppRoute } from 'appRoutes'
import { SuspectScoreAnalyticsPage, useFraudImportJobs } from 'features/suspectScore'
import { getLDFlag } from 'helpers/launchDarkly'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/suspect-score/analysis')({
  component: RouteComponent,
  beforeLoad: async ({ params, context }) => {
    const canAccess: boolean = getLDFlag('FRAUD_LABEL_IMPORT', false, context.ldClient)
    if (!canAccess) {
      throw redirect({ to: AppRoute.SuspectScore, params: { subscriptionId: params.subscriptionId } })
    }
  },
  head: () => ({
    meta: [
      {
        title: withCompanyName('Fraud Analysis'),
      },
    ],
  }),
})

function RouteComponent() {
  const { subscriptionId: workspaceId } = Route.useParams()
  const { data: importJobs, dataUpdatedAt } = useFraudImportJobs(workspaceId)

  return (
    <SuspectScoreAnalyticsPage
      workspaceId={workspaceId}
      importJobs={importJobs ?? { accepted: [], needsReview: [], processing: [], rejected: [] }}
      dataUpdatedAt={dataUpdatedAt}
    />
  )
}
